import React from "react";
import { normalizeUploadedImageUrl } from "../../apis/uploadImage";
import defaultBanner from "../../images/banner/banner---gioi-thieu.png";

function TopBanner({ imgBanner, text, pageName, titleCenter }) {
  const hasContent = Boolean(titleCenter || pageName || text);
  const resolvedImg = normalizeUploadedImageUrl(imgBanner) || defaultBanner;

  return (
    <section
      className={"top_banner" + (hasContent ? " top_banner--with-content" : "")}
    >
      <div
        className="top_banner-img"
        style={{ backgroundImage: `url(${resolvedImg})` }}
        aria-hidden="true"
      />
      {hasContent && (
        <div className="top_banner-title">
          <div className="layout_container">
            {titleCenter && <h4 className="title-zone">{titleCenter}</h4>}
            {(pageName || text) && (
              <p className="title-title">
                {pageName}
                {pageName && text ? " / " : ""}
                {text}
              </p>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default TopBanner;
